import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'power_multiplication_negative',
    dependencies: [
        'levels_maths/berengere_maths/positives_negatives_additions',
        'levels_maths/berengere_maths/power_zero'
    ]
})



//Multiplication de puissances avec exposant négatif - En ligne avec les pré-requis - La puissance n'excede pas 5
level.addQuestion({
    generator: function (q) {
        let base = 2
        let pow1 = random.fairChoiceInt(1, 6, {name: 'pow1'})
        let pow2 = random.fairChoiceInt(1, 6, {name: 'pow2'})

        if (pow1 >= pow2) {
            pow2 = -pow2
        } else {
            pow1 = -pow1
        }

        q.addMathFormula(base + '^\\color{blue}[' + pow1 + ']xx' + base + '^\\color{blue}[' + pow2 + ']')

        q.answer = Math.pow(base, pow1 + pow2)
    },
    times: 2

})


export default level

